export function initErrorHandlers() {
  initLogger()
}

function initLogger() {
  window.onerror = (messageOrEvent, source, lineno, colno, error) => {
    console.log({
      type: 'Runtime',
      messageOrEvent,
      source,
      lineno,
      colno,
      error: JSON.stringify(error)
    })
    return false
  }
}
